import { format } from 'date-fns';
import styled from 'styled-components';

import ChevronLeft from 'svg/ChevronLeft';

import useWeekNavigation from '../hooks/useWeekNavigation';

export default function DateNavigation() {
  const { startDate, endDate, goToNextWeek, goToPreviousWeek, goToToday, canGoNext, canGoPrevious } =
    useWeekNavigation();

  const formatDateRange = () => {
    const startDay = format(startDate, 'EEE, MMMM d, yyyy');
    const endDay = format(endDate, 'EEE, MMMM d, yyyy');
    return `${startDay} – ${endDay}`;
  };

  return (
    <Container>
      <ArrowGroup>
        <NavArrow onClick={goToPreviousWeek} disabled={!canGoPrevious} data-cy='nav-previous-week'>
          <ChevronLeft width={10} height={10} />
        </NavArrow>
        <NavArrow onClick={goToNextWeek} disabled={!canGoNext} aria-label='Next week' data-cy='nav-next-week'>
          <MirroredChevron width={10} height={10} />
        </NavArrow>
      </ArrowGroup>

      <DateRange data-cy='date-range'>{formatDateRange()}</DateRange>

      <TodayLink onClick={goToToday} data-cy='nav-today'>
        Today
      </TodayLink>
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const ArrowGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

const MirroredChevron = styled(ChevronLeft)`
  transform: scaleX(-1);
`;

const NavArrow = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border: none;
  background: transparent;
  color: ${({ theme }) => theme.colors.black};
  cursor: pointer;
  padding: 0;

  &:hover:not(:disabled) {
    opacity: 0.7;
  }

  &:disabled {
    opacity: 0.3;
    cursor: not-allowed;
  }
`;

const DateRange = styled.span`
  font-size: 14px;
  font-weight: var(--font-weight-bold);
  color: ${({ theme }) => theme.colors.black};
`;

const TodayLink = styled.button`
  font-size: 12px;
  font-weight: var(--font-weight-medium);
  color: ${({ theme }) => theme.colors.black};
  background-color: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.black25};
  border-radius: 4px;
  padding: 8px 16px;
  cursor: pointer;

  &:hover {
    background-color: ${({ theme }) => theme.colors.black05};
  }
`;
